module.exports = __webpack_public_path__ + "static/media/DOTB.1882c20b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/DOTB.jpg
// module id = 191
// module chunks = 0